/**
 * @generated SignedSource<<21aba3d3f0a884052785fc664cde4b06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteCommentInput = {
  commentId: string;
};
export type DeleteCommentMutation$variables = {
  input: DeleteCommentInput;
};
export type DeleteCommentMutation$data = {
  readonly deleteComment: {
    readonly deletedCommentId: string | null | undefined;
  } | null | undefined;
};
export type DeleteCommentMutation = {
  response: DeleteCommentMutation$data;
  variables: DeleteCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCommentPayload",
    "kind": "LinkedField",
    "name": "deleteComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCommentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21ae4471f4d6272bb68da2da6a7c06c4",
    "id": null,
    "metadata": {},
    "name": "DeleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCommentMutation(\n  $input: DeleteCommentInput!\n) {\n  deleteComment(input: $input) {\n    deletedCommentId\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3642394cdd94fefcce5ab37aeb4b78c";

export default node;
